import createAxiosInstance from './createAxiosInstance'

const path = process.env.VUE_APP_HOUSEKEEPER_API
const instance = createAxiosInstance(`${path}/api/v1`)

export const apiOrderFood = {
  /**
   * 取得餐點類別
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/get_api_v1_TableFoodMenu
   */
  getFoodMenu: () => instance.get('/TableFoodMenu'),
  /**
   * 新增餐點類別
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/post_api_v1_TableFoodMenu
   */
  addFoodMenu: (data) => instance.post('/TableFoodMenu', data),
  /**
   * 更新餐點類別
   * @param {*} id 類別ID
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/put_api_v1_TableFoodMenu__Id_
   */
  updateFoodMenu: (id, data) => instance.put(`/TableFoodMenu/${id}`, data),
  /**
   * 更新餐點類別排序
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/put_api_v1_TableFoodMenu_Sequence
   */
  updateFoodMenuSequence: (data) => instance.put('/TableFoodMenu/Sequence', data),
  /**
   * 刪除餐點類別
   * @param {*} id 類別ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/delete_api_v1_TableFoodMenu__Id_
   */
  deleteFoodMenu: (id) => instance.delete(`/TableFoodMenu/${id}`),
  /**
   * 取得規格列表
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/get_api_v1_TableFoodSpec
   */
  getFoodSpec: () => instance.get('/TableFoodSpec'),
  /**
   * 新增規格
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/post_api_v1_TableFoodSpec
   */
  addFoodSpec: (data) => instance.post('/TableFoodSpec', data),
  /**
   * 更新規格
   * @param {*} id 規格ID
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/put_api_v1_TableFoodSpec__Id_
   */
  updateFoodSpec: (id, data) => instance.put(`/TableFoodSpec/${id}`, data),
  /**
   * 更新規格排序
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/put_api_v1_TableFoodSpec_Sequence
   */
  updateFoodSpecSequence: (data) => instance.put('/TableFoodSpec/Sequence', data),
  /**
   * 刪除規格
   * @param {*} id 規格ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/delete_api_v1_TableFoodSpec__Id_
   */
  deleteFoodSpec: (id) => instance.delete(`/TableFoodSpec/${id}`),
  /**
   * 查詢使用特定規格的項目
   * @param {*} id 規格ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/get_api_v1_TableFoodSpec__Id__Used_Items
   */
  getFoodSpecUsedItems: (id) => instance.get(`/TableFoodSpec/${id}/Used-Items`),
  /**
   * 取得餐桌美食表單列表
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodForm/get_api_v1_TableFoodForm
   */
  getFoodFormList: (params) => instance.get('/TableFoodForm', { params }),
  /**
   * 取得餐桌美食表單(單筆)
   * @param {*} id 表單ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodForm/get_api_v1_TableFoodForm__Id_
   */
  getFoodFormData: (id) => instance.get(`/TableFoodForm/${id}`),
  /**
   * 新增餐桌美食表單
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodForm/post_api_v1_TableFoodForm
   */
  addFoodForm: (data) => instance.post('/TableFoodForm', data),
  /**
   * 匯出餐桌美食表單
   * @param {*} params 參數資料
   * @param {*} config 設定
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodForm/get_api_v1_TableFoodForm_Export
   */
  exportFoodForm: (params, config) => instance.get('/TableFoodForm/Export', Object.assign({}, { params }, config)),
  /**
   * 作廢餐桌美食表單
   * @param {*} id 表單ID
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodForm/put_api_v1_TableFoodForm__Id__Void
   */
  voidFoodForm: (id, data) => instance.put(`/TableFoodForm/${id}/Void`, data),
  /**
   * 點數餐桌美食 - 列表
   * 使用頁面: 點餐紀錄(舊)
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/PointTableFood/get_api_v1_PointTableFood
   */
  getPointTableFoodList: (params) => instance.get('/PointTableFood', { params }),
  /**
   * 點數餐桌美食 - 作廢
   * 使用頁面: 點餐紀錄(舊)
   * @param {*} id 表單ID
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/PointTableFood/put_api_v1_PointTableFood__Id__void
   */
  voidPointTableFood: (id, data) => instance.put(`/PointTableFood/${id}/void`, data),
  /**
   * 點數餐桌美食 - 補單
   * 1. 取得點餐明細
   * 使用頁面: 點餐紀錄(舊)
   * @param {*} id 表單ID
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/PointTableFood/get_api_v1_PointTableFood__Id__ThermalPaper
   */
  getPointTableFoodDetail: (id) => instance.get(`/PointTableFood/${id}/ThermalPaper`),
  /**
   * 點數餐桌美食 - 匯出
   * 使用頁面: 點餐紀錄(舊)
   * @param {*} params 參數資料
   * @param {*} config 設定
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/PointTableFood/get_api_v1_PointTableFood_Export
   */
  exportPointTableFood: (params, config) => instance.get('/PointTableFood/Export', Object.assign({}, { params }, config)),
  /**
   * 餐桌美食菜單匯出存儲-取得已完成可下載入數量
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/get_api_v1_TableFoodExportStorage_Completed_And_Downloadable
   */
  getCompletedAndDownloadable: (params) => instance.get('/TableFoodExportStorage/Completed-And-Downloadable', { params }),
  /**
   * 餐桌美食菜單匯出存儲-取得列表
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/get_api_v1_TableFoodExportStorage
   */
  getTableFoodExportStorageList: (params) => instance.get('/TableFoodExportStorage', { params }),
  /**
   * 餐桌美食菜單匯出存儲-申請匯出
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/post_api_v1_TableFoodExportStorage
   */
  postTableFoodExportStorage: (data) => instance.post('/TableFoodExportStorage', data),
  /**
   * 餐桌美食菜單匯出存儲-下載網址加密
   * @param {string} id 資料ID
   * @param {*} config 設定
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/get_api_v1_TableFoodExportStorage__Id__Url_Signer
   */
  downloadTableFoodExportStorage: (id, config) => instance.get(`/TableFoodExportStorage/${id}/Url-Signer`, Object.assign({}, config)),
  /**
   * 取得社區開通點數類型
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/Point/get_api_v1_Point_Point_Type
   */
  getPointType: () => instance.get('/Point/Point-Type'),
  /**
   * 取得社區戶別-手機條碼
   * @param {string} deviceSn 手機條碼
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/CommunityTablet/get_api_v1_CommunityTablet__DeviceSn__Device
   */
  getCommunityTabletsByPhone: (deviceSn) => instance.get(`CommunityTablet/${deviceSn}/Device`),
  /**
   * 取得社區戶別-載具(門禁卡、磁扣)
   * @param {string} code 代碼
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/CommunityTablet/get_api_v1_CommunityTablet__Code__Carrier
   */
  getCommunityTabletsByCarrier: (code) => instance.get(`CommunityTablet/${code}/Carrier`),
  /**
   * 點數-用戶查詢點數
   * @param {string} tabletId 戶別ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/Point/get_api_v1_Point__TabletId__Points
   */
  getCommunityTabletPoints: (tabletId) => instance.get(`Point/${tabletId}/Points`)
}
